import { useBreakpointValue } from "@chakra-ui/react";
import { useWatch } from "react-hook-form";

import { SelectFormInput } from "components/inputs";
import { RequestContractFormProps } from "forms/RequestContractForm/RequestContractForm";
import { useGetRequestContractShipFroms } from "hooks/api/requestContract";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import useSingleOptionAsFormDefault from "hooks/useSingleOptionAsFormDefault";
import { mobileOnly } from "util/styleHelpers";

const ShipFromSelect = ({ id }: { id: string }) => {
  const selectedCustomerCode = useSelectedCustomerCode()[0];
  const { product } = useWatch<RequestContractFormProps>();
  const { data, isInitialLoading } = useGetRequestContractShipFroms(
    selectedCustomerCode,
    product?.value
  );
  useSingleOptionAsFormDefault(id, data);
  const showLabel = useBreakpointValue(mobileOnly, { ssr: false });
  return (
    <SelectFormInput
      id={id}
      options={data}
      isLoading={isInitialLoading}
      isDisabled={!product?.value}
      label={showLabel ? "Ship From" : undefined}
    />
  );
};

export default ShipFromSelect;
